"use client"

import { useReportWebVitals } from "next/web-vitals"

export function WebVitals() {
  useReportWebVitals((metric) => {
    // Отправка метрик в систему аналитики (например, Google Analytics, Vercel Analytics)
    // const body = JSON.stringify({
    //   name: metric.name,
    //   value: metric.value,
    //   rating: metric.rating,
    //   delta: metric.delta,
    //   id: metric.id,
    // })

    // Для development режима выводим в консоль
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Web Vitals] ${metric.name}:`, metric.value, `(${metric.rating})`)
    }

    // Отправка метрик (можно добавить Google Analytics, Vercel Analytics или другую систему)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', metric.name, {
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_category: 'Web Vitals',
        event_label: metric.id,
        non_interaction: true,
      })
    }

    // Альтернативно: отправка на собственный endpoint
    // if (navigator.sendBeacon) {
    //   navigator.sendBeacon('/api/analytics/web-vitals', body)
    // }
  })

  return null
}

// Расширение типов для window.gtag
declare global {
  interface Window {
    gtag?: (
      command: 'event',
      eventName: string,
      eventParams?: Record<string, unknown>
    ) => void
  }
}

